import { CIMSPage, Permission } from '@cims-online/shared'
import { Switch } from 'react-router-dom'
import React from 'react'
import { ProtectedRoute } from 'components/ProtectedRoute'
import Manage from './components/Manage'
import Summary from './components/Summary'
import PayItemsModuleProvider from './PayItemsModuleContext'

const PayItems: React.FC = () => {
  return (
    <PayItemsModuleProvider>
      <Switch>
        <ProtectedRoute
          path={CIMSPage.PayItemsSummary.projectPath}
          permissions={Permission.ViewPayItemSummary}
        >
          <Summary />
        </ProtectedRoute>
        <ProtectedRoute
          path={CIMSPage.ManagePayItems.projectPath}
          permissions={[
            Permission.ViewPayItemConnection,
            Permission.ViewPayItemConnectionGroup,
          ]}
        >
          <Manage />
        </ProtectedRoute>
      </Switch>
    </PayItemsModuleProvider>
  )
}

export default PayItems
